import Marquee from "react-fast-marquee";

const ITEMS = ["Holiday Packages", "Visa Assistance", "Travel Insurance", "Honeymoon Specials", "Group Tours", "Corporate Travel", "Forex", "24/7 Trip Support"];

export const EditorialMarquee = ({ dark = true }) => (
  <div className={`py-5 border-y overflow-hidden ${dark ? "bg-ink border-bone/10 text-bone/40" : "bg-bone border-ink/10 text-ink/40"}`} data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="mx-8 font-display text-sm uppercase tracking-[0.3em] flex items-center gap-8">
          {item} <span className="text-sun text-xs">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
